import { render, staticRenderFns } from "./VimeoExpansionPanel.vue?vue&type=template&id=80c73e32&scoped=true&"
import script from "./VimeoExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./VimeoExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./VimeoExpansionPanel.vue?vue&type=style&index=0&id=80c73e32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c73e32",
  null
  
)

export default component.exports